<template>
  <v-card-text class="py-3">
    <div v-if="defecationTemp"  class="d-flex align-center justify-center mb-5">
      <div>修正前：　</div>
      <v-chip color="defecation" class="mr-2" variant="outlined" size="x-small">排便</v-chip>
      <div class="">{{ formatTime(defecationTemp.recordedAt) }}</div>
      <div class="ml-4">{{ showDefecationStatus(defecationTemp.state) }}</div>
    </div>
    <v-menu
      v-model="isRecordetAtPicker"
      :close-on-content-click="false"
      location="bottom start"
      transition="scale-transition"
      min-width="290px"
      max-width="290px"
    >
      <template v-slot:activator="{ props }">
        <v-text-field
          :model-value="localRecordedAt"
          label="時間"
          prepend-icon="mdi-clock-time-four-outline"
          :rules="[rules.required]"
          readonly
          v-bind="props"
          variant="outlined"
          density="compact"
          color="primary"
        ></v-text-field>
      </template>

      <v-time-picker
        v-if="isRecordetAtPicker"
        v-model="localRecordedAt"
        format="24hr"
        locale="ja"
        :allowed-minutes="allowedStep"
        @update:model-value="onTimePicked"
        color="primary"
        @keydown.capture.prevent
      ></v-time-picker>
    </v-menu>

    <v-select
      :model-value="state"
      @update:model-value="onChangeState"
      :items="choices"
      item-title="text"
      item-value="value"
      :rules="[rules.required]"
      label="状態"
      variant="outlined"
      density="compact"
    ></v-select>
  </v-card-text>
</template>
<script lang="ts">
import Vue, { PropType, defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import { DefecationStatus, DefecationStatusType, NurseryDefecationResponse } from 'chaild-api/lib';
dayjs.locale('ja');
import rules from '@/service/ValidRules';

// model
// import { VForm } from '@/model/vuetify/VForm';

export default defineComponent({
  name: 'DefecationModal',

  emits: ['update:recordedAt', 'update:state'],

  props: {
    childId: {
      type: Number,
      default: NaN,
    },
    selectedDate: {
      type: String,
      default: dayjs().format('YYYY-MM-DD'),
    },
    defecationTemp: {
      type: Object as PropType<NurseryDefecationResponse>,
    },
    recordedAt: {
      type: String,
      default: '',
    },
    state: {
      type: String,
      default: '',
    },
  },

  computed: {
    rules() {
      return rules;
    },
    form() {
      return (this.$refs as any).post_defecation_form;
    },
  },

  watch: {
    recordedAt(newVal) {
      if (newVal) {
        this.localRecordedAt = dayjs(newVal).format('HH:mm');
      } else {
        this.localRecordedAt = '';
      }
    },
  },

  data: () => ({
    btnLoading: false,
    isRecordetAtPicker: false,
    localRecordedAt: '',
    choices: [
      {
        text: '硬い',
        value: DefecationStatus.hard,
      },
      {
        text: '普通',
        value: DefecationStatus.normal,
      },
      {
        text: '軟らかい',
        value: DefecationStatus.soft,
      },
      {
        text: '水様便（下痢）',
        value: 'diarrhea' as DefecationStatusType,
      },
    ],
  }),

  methods: {
    allowedStep: (m: any) => m % 5 === 0,
    onTimePicked(newTime: string | null) {
      if (!newTime) return;
      this.localRecordedAt = newTime;
      const [hour, minute] = newTime.split(':');
      const iso = dayjs().hour(Number(hour)).minute(Number(minute)).second(0).millisecond(0).toISOString();
      this.$emit('update:recordedAt', iso);
      this.isRecordetAtPicker = false;
    },
    onChangeState(newState: string) {
      this.$emit('update:state', newState);
    },
    showDefecationStatus(state: DefecationStatusType) {
      if (state === 'hard') {
        return '硬い';
      } else if (state === 'normal') {
        return '普通';
      } else if (state === 'soft') {
        return '柔らかい';
      } else if (state === 'diarrhea') {
        return '水様便（下痢）';
      }
    },
    formatTime(time: string) {
      const nowTime = dayjs(time).format('HH:mm');
      return nowTime;
    },
  },
  mounted() {
    if (this.recordedAt) {
      this.localRecordedAt = dayjs(this.recordedAt).format('HH:mm');
    }
  },
});
</script>
<style lang="scss" scoped></style>
